import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'plys-timer',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './timer.component.html',
  styleUrls: ['./timer.component.scss'],
})
export class TimerComponent implements OnInit {
  @Input() time: number;
  @Input() expired = false;
  dutch: boolean;
  constructor(private translocoService: TranslocoService) {
    this.dutch = this.translocoService.getActiveLang() === 'nl';
  }
  ngOnInit(): void {}
}
